import React from 'react'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { BRAND_PALETTE, ACCENT_PALETTE } from '../config/branding'

const theme = extendTheme({
  fonts: {
    heading: 'Geomanist',
    body: 'Geomanist'
  },
  colors: {
    brand: BRAND_PALETTE,
    accent: ACCENT_PALETTE
  }
})

const ThemeProvider = ({ children }) => {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default ThemeProvider
